/**
 * @fileoverview
 * Radar System for Space Ship
 */
'use strict';

goog.provide("Ntry.RadarSystem");

goog.require("Ntry.STATIC");

Ntry.RadarSystem = function() {
    this._radarGrid = {
        x: -1, y: -1
    };

    this._spaceWidth = 0;;
    Ntry.addEventListener("triggerWeapon", this, this.updateRadar);
    Ntry.addEventListener("restoreEnd", this, this.updateRadar);
};

(function(p){
    p.update = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.RADAR
        );

        if (_.isEmpty(entities))
            return;

        var entity = _.values(entities)[0];

        var gridComp = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.GRID
        );

        if (gridComp.x == this._radarGrid.x &&
            gridComp.y == this._radarGrid.y)
            return;

        /* end of map */
        if (gridComp.x >= this._spaceWidth)
            return;

        this.updateRadar();
    };

    p.updateRadar = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.RADAR
        );

        if (_.isEmpty(entities))
            return;

        var entity = _.values(entities)[0];

        var radar = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.RADAR
        );
        var gridComp = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.GRID
        );

        switch(gridComp.y) {
            case 0:
                radar.left = {distance: 0, type: Ntry.STATIC.AI_WALL};
                radar.center = this.seekLine(gridComp.x, 0);
                radar.right = this.seekLine(gridComp.x, 1);
                break;
            case 1:
                radar.left = this.seekLine(gridComp.x, 0);
                radar.center = this.seekLine(gridComp.x, 1);
                radar.right = this.seekLine(gridComp.x, 2);
                break;
            case 2:
                radar.left = this.seekLine(gridComp.x, 1);
                radar.center = this.seekLine(gridComp.x, 2);
                radar.right = {distance: 0, type: Ntry.STATIC.AI_WALL};
                break;
        }

        this._radarGrid.x = gridComp.x;
        this._radarGrid.y = gridComp.y;
    }

    p.loadConfig = function() {
        this._spaceWidth = Ntry.configManager.getConfig("spaceWidth");
    };

    p.seekLine = function(start, line) {
        var entities = [];
        var xPos = start;
        while (entities.length == 0 && xPos < start + 10) {
            xPos++;
            entities = Ntry.entityManager.find({
                 type: Ntry.STATIC.GRID,
                 x: xPos,
                 y: line
            });
        }

        var itemType = Ntry.STATIC.AI_GOAL;
        for (var id in entities) {
            var entity = entities[id];
            itemComp = Ntry.entityManager.getComponent(
                entity.id, Ntry.STATIC.ITEM
            );
            if (itemComp)
                itemType = itemComp.itemType;
        }

        return {
            distance: xPos - start,
            type: itemType
        }
    };

})(Ntry.RadarSystem.prototype);
